































import Vue from 'vue';
import { editTypeTranscoderDialog, PREF_FULLSCREEN_EDIT_TRANSCODER } from './EditEntityTranscoder';
import { Preferences } from './Preference';


export default Vue.extend({
  data: () => editTypeTranscoderDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
    title(): string {
      return `Transcoder for "${this.property}"`;
    },
    isSaved(): boolean {
      return this.entity.transcoders[this.property] === this.transcoder;
    },
    buttonText(): string {
      return this.isSaved ? this.confirm : this.unconfirm;
    },
  },
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;

      Preferences.set(PREF_FULLSCREEN_EDIT_TRANSCODER, this.fullscreen);
    },
    finish() {
      this.handle(this.isSaved);
    },
  },
});
